import React, { useState, useEffect, useMemo } from "react";
import Select from "react-select";
import axios from "axios";
import "./balance.css";
import { executeupdatequery,getvendorcode, getBalanceFromServer,updatedonutvalue,updateclosurestatusvalue,Fetcherpdata_1,Fetchexecutequery,Fetchbankdata_1,Fetchbankinvoicedetails1,Fetchbankdata,Fetchexternaldetails, getProcessingLayerDataFromServer, getProcessingLayerDataWithStatusFromServer, getUpdateMatchRecordsFromServer, getUpdateUnMatchRecordsFromServer, getUpdateDuplicateRecordsFromServer, getUpdateContraRecordsFromServer, getProcessingLayerDataReturnFromServer, getUpdateGlBalFromServer, getUpdateBankBalFromServer, Fetchbankinvoicedetails,Fetcherpdata, Fetchmatchedutrdata, Fetchmatchedutrdata1, updatestatusvalue, allocateupdatestatusvalue, fetchmonthwisedata1, getdonutseriesdata, getkpidatarecon, getpaymenthistory, getstatustypeslist, getremarksdata, fetchmonthwisedatanew, getpaymenthistorynew,Fetchbalupdationquery, getdataforcardsrecon } from '../../../services/demo/brs/brsService1';

import { Input,Button } from 'semantic-ui-react';

const BalanceClosing = () => {
  const [options, setOptions] = useState([]);
  const [selectedDivision, setSelectedDivision] = useState(null);
  const [selectedEntity, setSelectedEntity] = useState(null);
  const [selectedGlCode, setSelectedGlCode] = useState(null);
  const [selectedAcctNo, setSelectedAcctNo] = useState(null);
  const [selectedGlDesc, setSelectedGlDesc] = useState(null);
  const [inputMonth, setInputMonth] = useState(undefined);
  const [balanceData, setBalanceData] = useState(null);
  const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));



  const callExecuteQuery = async (query) => {
    try {
      const [headers, url] = Fetchexecutequery(query);
      const response = await axios.post(url, { query }, headers);
      return response.data;
    } catch (error) {
      console.error("Error executing query:", error);
      return [];
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const query =
        "SELECT primary_id, gl_code, gldesc, account_number, Entity, division_name FROM txbrs.account_master where is_active=1 ORDER BY gl_code;";
      const data = await callExecuteQuery(query);

      if (data) {
        const processedOptions = data.map((item) => ({
          id: item.primary_id,
          gl_code: item.gl_code,
          gldesc: item.gldesc,
          acct: item.account_number,
          entity: item.Entity,
          division: item.division_name,
        }));
        setOptions(processedOptions);
      }
    };

    fetchData();
  }, []);

  // Entity Options
  const entityOptions = useMemo(() => {
    const filteredEntities = options.filter((item) => !selectedDivision || item.division === selectedDivision);
    const uniqueEntities = Array.from(new Set(filteredEntities.map(item => item.entity)));
    return uniqueEntities.map(value => ({
      value,
      label: value
    }));
  }, [options, selectedDivision]);

  // Division Options
  const divisionOptions = useMemo(() => {
    const filteredDivisions = options.filter((item) => !selectedEntity || item.entity === selectedEntity);
    const uniqueDivisions = Array.from(new Set(filteredDivisions.map(item => item.division)));
    return uniqueDivisions.map(value => ({
      value,
      label: value
    }));
  }, [options, selectedEntity]);

  // GL Code Options with Entity, Division, and Description (hidden but used for filtering)
  const glCodeOptions = useMemo(() => {
    const filteredGLCodes = options.filter(
      (item) =>
        (!selectedEntity || item.entity === selectedEntity) &&
        (!selectedDivision || item.division === selectedDivision)
    );

    // Ensure uniqueness of gl_code, entity, and division combinations
    const uniqueGLCodes = filteredGLCodes.reduce((acc, curr) => {
      const key = `${curr.gl_code}-${curr.entity}-${curr.division}`;  // Unique key based on gl_code, entity, and division
      if (!acc[key]) {
        acc[key] = curr;
      }
      return acc;
    }, {});

    return Object.values(uniqueGLCodes).map(item => ({
      value: item.gl_code,
      label: item.gl_code,  // Only displaying GL Code
      entity: item.entity,  // Hidden for internal filtering
      division: item.division,  // Hidden for internal filtering
      gldesc: item.gldesc,  // Hidden for internal filtering
    }));
  }, [options, selectedEntity, selectedDivision, selectedGlDesc]);


const monthendclosebalance = async () => {
  let [year, month] = inputMonth.split('-');
  let formattedMonth = `${parseInt(month)}-${year}`; // Convert month to integer to remove leading zero
  let currentDateTime = new Date().toISOString().slice(0, 19).replace("T", " "); // Format: YYYY-MM-DD HH:MM:SS


  let payload1 = {
    set_column: { "close_status": 1,"closed_by":userCredentials.user_id,"closed_date": currentDateTime},
    where: [{ month: formattedMonth }, { gl_code: selectedGlCode }, { division_name: selectedDivision }],
    schema_name: 'BRS',
    table: 'month_end_balance'
  };

  let payload2 = {
    query: `
    UPDATE txbrs.erp SET close_status = 1
    WHERE glcd = '${selectedGlCode}' 
    AND division = '${selectedDivision}' AND match_status != 'Unmatched'
    AND STR_TO_DATE(\`gl date\`, '%d-%b-%Y') <= STR_TO_DATE('01-${month}-${year}', '%d-%m-%Y');`
  };

  let payload3 = {
    query: `
    UPDATE txbrs.bank SET close_status = 1
    WHERE gl_code = '${selectedGlCode}' 
    AND division = '${selectedDivision}' AND match_status != 'Unmatched' 
    AND STR_TO_DATE(\`entry date\`, '%d-%b-%Y') <= STR_TO_DATE('01-${month}-${year}', '%d-%m-%Y');`
  };

  let payload4 = {
    query: `
    UPDATE txbrs.erp SET close_status = 0
    WHERE glcd = '${selectedGlCode}' 
    AND division = '${selectedDivision}' AND match_status = 'Unmatched';`
  };

  let payload5 = {
    query: `
    UPDATE txbrs.bank SET close_status = 0
    WHERE gl_code = '${selectedGlCode}' 
    AND division = '${selectedDivision}' AND match_status = 'Unmatched';`
  };

  try {
    let getProcessingLayerData = updateclosurestatusvalue();  // For payload1
    let getProcessingLayerData1 = executeupdatequery();       // For payload2 & payload3

    // First API call to update `month_end_balance` table
    const response1 = await axios.post(getProcessingLayerData[1], payload1, getProcessingLayerData[0]);

    if (response1.status !== 200) {
      console.error("Error updating first table:", response1);
      alert("Error updating first table: " + (response1.data?.message || "Unknown error"));
      return;
    }

    // Second API call to update `erp` table
    const response2 = await axios.post(getProcessingLayerData1[1], payload2, getProcessingLayerData1[0]);

    if (response2.status !== 200) {
      console.error("Error updating second table:", response2);
      alert("Error updating second table: " + (response2.data?.message || "Unknown error"));
      return;
    }

    // Third API call to update `bank` table
    const response3 = await axios.post(getProcessingLayerData1[1], payload3, getProcessingLayerData1[0]);

    if (response3.status !== 200) {
      console.error("Error updating third table:", response3);
      alert("Error updating third table: " + (response3.data?.message || "Unknown error"));
      return;
    }

    const response4 = await axios.post(getProcessingLayerData1[1], payload4, getProcessingLayerData1[0]);

    if (response4.status !== 200) {
      console.error("Error updating 4th table:", response4);
      alert("Error updating 4th table: " + (response4.data?.message || "Unknown error"));
      return;
    }

    const response5 = await axios.post(getProcessingLayerData1[1], payload5, getProcessingLayerData1[0]);
    if (response5.status !== 200) {
      console.error("Error updating 5th table:", response5);
      alert("Error updating 5th table: " + (response5.data?.message || "Unknown error"));
      return;
    }

    alert("Records Locked successfully!");
  } catch (error) {
    console.error("Error updating tables:", error);
    alert("An error occurred while updating the tables.");
  }
};

const monthendfreezebalance = async () => {
  let [year, month] = inputMonth.split('-');
  let formattedMonth = `${parseInt(month)}-${year}`; // Convert month to integer to remove leading zero

  let payload1 = {
    set_column: { "close_status": 2 },
    where: [{ month: formattedMonth }, { gl_code: selectedGlCode }, { division_name: selectedDivision }],
    schema_name: 'BRS',
    table: 'month_end_balance'
  };

  let payload2 = {
    query: `
    UPDATE txbrs.erp SET close_status = 2
    WHERE glcd = '${selectedGlCode}' 
    AND division = '${selectedDivision}'
    AND MONTH(STR_TO_DATE(\`gl date\`, '%d-%b-%Y')) = '${month}' 
    AND YEAR(STR_TO_DATE(\`gl date\`, '%d-%b-%Y')) = '${year}';`
  };

  let payload3 = {
    query: `
    UPDATE txbrs.bank SET close_status = 2
    WHERE gl_code = '${selectedGlCode}' 
    AND division = '${selectedDivision}' 
    AND MONTH(STR_TO_DATE(\`entry date\`, '%d-%b-%Y')) = '${month}' 
    AND YEAR(STR_TO_DATE(\`entry date\`, '%d-%b-%Y')) = '${year}';`
  };

  try {
    let getProcessingLayerData = updateclosurestatusvalue();  // For payload1
    let getProcessingLayerData1 = executeupdatequery();       // For payload2 & payload3

    // First API call to update `month_end_balance` table
    const response1 = await axios.post(getProcessingLayerData[1], payload1, getProcessingLayerData[0]);

    if (response1.status !== 200) {
      console.error("Error updating first table:", response1);
      alert("Error updating first table: " + (response1.data?.message || "Unknown error"));
      return;
    }

    // Second API call to update `erp` table
    const response2 = await axios.post(getProcessingLayerData1[1], payload2, getProcessingLayerData1[0]);

    if (response2.status !== 200) {
      console.error("Error updating second table:", response2);
      alert("Error updating second table: " + (response2.data?.message || "Unknown error"));
      return;
    }

    // Third API call to update `bank` table
    const response3 = await axios.post(getProcessingLayerData1[1], payload3, getProcessingLayerData1[0]);

    if (response3.status !== 200) {
      console.error("Error updating third table:", response3);
      alert("Error updating third table: " + (response3.data?.message || "Unknown error"));
      return;
    }

    alert("Records Freezed successfully!");
  } catch (error) {
    console.error("Error updating tables:", error);
    alert("An error occurred while updating the tables.");
  }
};

const monthendunfreezebalance = async () => {
  let [year, month] = inputMonth.split('-');
  let formattedMonth = `${parseInt(month)}-${year}`; // Convert month to integer to remove leading zero

  let payload1 = {
    set_column: { "close_status": 0 },
    where: [{ month: formattedMonth }, { gl_code: selectedGlCode }, { division_name: selectedDivision }],
    schema_name: 'BRS',
    table: 'month_end_balance'
  };

  let payload2 = {
    query: `
    UPDATE txbrs.erp SET close_status = 0
    WHERE glcd = '${selectedGlCode}' 
    AND division = '${selectedDivision}'
    AND MONTH(STR_TO_DATE(\`gl date\`, '%d-%b-%Y')) = '${month}' 
    AND YEAR(STR_TO_DATE(\`gl date\`, '%d-%b-%Y')) = '${year}';`
  };

  let payload3 = {
    query: `
    UPDATE txbrs.bank SET close_status = 0
    WHERE gl_code = '${selectedGlCode}' 
    AND division = '${selectedDivision}' 
    AND MONTH(STR_TO_DATE(\`entry date\`, '%d-%b-%Y')) = '${month}' 
    AND YEAR(STR_TO_DATE(\`entry date\`, '%d-%b-%Y')) = '${year}';`
  };

  try {
    let getProcessingLayerData = updateclosurestatusvalue();  // For payload1
    let getProcessingLayerData1 = executeupdatequery();       // For payload2 & payload3

    // First API call to update `month_end_balance` table
    const response1 = await axios.post(getProcessingLayerData[1], payload1, getProcessingLayerData[0]);

    if (response1.status !== 200) {
      console.error("Error updating first table:", response1);
      alert("Error updating first table: " + (response1.data?.message || "Unknown error"));
      return;
    }

    // Second API call to update `erp` table
    const response2 = await axios.post(getProcessingLayerData1[1], payload2, getProcessingLayerData1[0]);

    if (response2.status !== 200) {
      console.error("Error updating second table:", response2);
      alert("Error updating second table: " + (response2.data?.message || "Unknown error"));
      return;
    }

    // Third API call to update `bank` table
    const response3 = await axios.post(getProcessingLayerData1[1], payload3, getProcessingLayerData1[0]);

    if (response3.status !== 200) {
      console.error("Error updating third table:", response3);
      alert("Error updating third table: " + (response3.data?.message || "Unknown error"));
      return;
    }

    alert("Records UnFreezed successfully!");
  } catch (error) {
    console.error("Error updating tables:", error);
    alert("An error occurred while updating the tables.");
  }
};


const handleSearchClick = async () => {
  let [year, month] = inputMonth.split('-');
  let formattedMonth = `${parseInt(month)}-${year}`; // Convert month to integer to remove leading zero


  // Corrected query string with template literals
  const query = `
    SELECT gldesc,FORMAT(erp_opening_balance, 2) AS erp_opening_balance,FORMAT(bank_opening_balance, 2) AS bank_opening_balance, 
    FORMAT(erp_closing_balance, 2) AS erp_closing_balance, FORMAT(bank_closing_balance, 2) AS bank_closing_balance,gl_code,close_status FROM txbrs.month_end_balance
    WHERE gl_code = '${selectedGlCode}' 
    AND division_name = '${selectedDivision}' AND month = '${formattedMonth}';
  `;

  // Call the function to execute the query
  const data = await callExecuteQuery(query);

  if (data) {
	const result = data[0];
    const roundedResult = {
  ...result,
};
	setBalanceData(roundedResult);
	console.log(result);
  }
};


  // Account Number Options with Entity, Division, and Description (hidden but used for filtering)
  const acctNoOptions = useMemo(() => {
    const filteredAccounts = options.filter(
      (item) =>
        (!selectedEntity || item.entity === selectedEntity) &&
        (!selectedDivision || item.division === selectedDivision)
    );

    // Ensure uniqueness of account number, entity, and division combinations
    const uniqueAccounts = filteredAccounts.reduce((acc, curr) => {
      const key = `${curr.acct}-${curr.entity}-${curr.division}`;  // Unique key based on acct, entity, and division
      if (!acc[key]) {
        acc[key] = curr;
      }
      return acc;
    }, {});

    return Object.values(uniqueAccounts).map(item => ({
      value: item.acct,
      label: item.acct,  // Only displaying Account Number
      entity: item.entity,  // Hidden for internal filtering
      division: item.division,  // Hidden for internal filtering
      gldesc: item.gldesc,  // Hidden for internal filtering
    }));
  }, [options, selectedEntity, selectedDivision,selectedGlDesc]);

  // GL Description Options (linked to GL Code and Account Number)

  const glDescOptions = useMemo(() => {
    const filteredDescriptions = options.filter(
      (item) =>
        (!selectedEntity || item.entity === selectedEntity) &&
        (!selectedDivision || item.division === selectedDivision)
    );

    // Ensure uniqueness of account number, entity, and division combinations
    const uniqueDescriptions = filteredDescriptions.reduce((acc, curr) => {
      const key = `${curr.gldesc}-${curr.entity}-${curr.division}`;  // Unique key based on acct, entity, and division
      if (!acc[key]) {
        acc[key] = curr;
      }
      return acc;
    }, {});

    return Object.values(uniqueDescriptions).map(item => ({
      value: item.gldesc,
      label: item.gldesc,  // Only displaying Account Number
      entity: item.entity,  // Hidden for internal filtering
      division: item.division,  // Hidden for internal filtering
    }));
  }, [options, selectedEntity, selectedDivision]);


const glDescOptions1 = useMemo(() => {
    const filteredDescriptions = options.filter(
        (item) =>
            (!selectedEntity || item.entity === selectedEntity) &&
            (!selectedDivision || item.division === selectedDivision) &&
            (!selectedGlCode || item.gl_code === selectedGlCode) &&
            (!selectedAcctNo || item.acct === selectedAcctNo)
    );

    // Ensure uniqueness based on GL Description + GL Code + Account Number + Entity + Division
    const uniqueDescriptions = filteredDescriptions.reduce((acc, curr) => {
        const key = `${curr.gldesc}-${curr.gl_code}-${curr.acct}-${curr.entity}-${curr.division}`;
        if (!acc[key]) {
            acc[key] = curr;
        }
        return acc;
    }, {});

    return Object.values(uniqueDescriptions).map(item => ({
        value: item.gldesc,
        label: item.gldesc,  
        gl_code: item.gl_code, 
        account_number: item.acct, 
        entity: item.entity, 
        division: item.division 
    }));
}, [options, selectedEntity, selectedDivision]);

  // Handle Entity Change
  const handleEntityChange = (selectedOption) => {
    setSelectedEntity(selectedOption ? selectedOption.value : null);
    setSelectedGlCode(null);  // Reset GL Code when Entity is changed
    setSelectedAcctNo(null);  // Reset Account Number when Entity is changed
    setSelectedGlDesc(null);  // Reset GL Description when Entity is changed
  };

  // Handle Division Change
  const handleDivisionChange = (selectedOption) => {
    setSelectedDivision(selectedOption ? selectedOption.value : null);
    setSelectedGlCode(null);  // Reset GL Code when Division is changed
    setSelectedAcctNo(null);  // Reset Account Number when Division is changed
    setSelectedGlDesc(null);  // Reset GL Description when Division is changed
  };

  // Handle GL Code Change (Autofill related fields)
  const handleGlCodeChange = (selectedOption) => {
    if (selectedOption) {
      const selectedItem = options.find(
        (item) => item.gl_code === selectedOption.value && item.entity === selectedOption.entity && item.division === selectedOption.division
      );
      if (selectedItem) {
        setSelectedGlCode(selectedItem.gl_code);
        setSelectedAcctNo(selectedItem.acct);
        setSelectedEntity(selectedItem.entity);
        setSelectedDivision(selectedItem.division);
        setSelectedGlDesc(selectedItem.gldesc); // Auto-fill GL Description
      }
    } else {
      setSelectedGlCode(null);
      setSelectedAcctNo(null);
      setSelectedGlDesc(null);
    }
  };

  // Handle Account Number Change (Autofill related fields)
  const handleAcctNoChange = (selectedOption) => {
    if (selectedOption) {
      const selectedItem = options.find(
        (item) => item.acct === selectedOption.value && item.entity === selectedOption.entity && item.division === selectedOption.division
      );
      if (selectedItem) {
        setSelectedAcctNo(selectedItem.acct);
        setSelectedGlCode(selectedItem.gl_code);
        setSelectedEntity(selectedItem.entity);
        setSelectedDivision(selectedItem.division);
        setSelectedGlDesc(selectedItem.gldesc); // Auto-fill GL Description
      }
    } else {
      setSelectedAcctNo(null);
      setSelectedGlCode(null);
      setSelectedGlDesc(null);
    }
  };

  // Handle GL Description Change (Autofill related fields)
  const handleGlDescChange = (selectedOption) => {
    if (selectedOption) {
      const selectedItem = options.find(
        (item) => item.gldesc === selectedOption.value && item.entity === selectedOption.entity && item.division === selectedOption.division
      );
      if (selectedItem) {
        setSelectedAcctNo(selectedItem.acct);
        setSelectedGlCode(selectedItem.gl_code);
        setSelectedEntity(selectedItem.entity);
        setSelectedDivision(selectedItem.division);
        setSelectedGlDesc(selectedItem.gldesc); // Auto-fill GL Description
      }
    } else {
      setSelectedAcctNo(null);
      setSelectedGlCode(null);
      setSelectedGlDesc(null);
    }
  };

  return (
   <div>
    <div className="filter-container">
      <div className="filter-row">
              <div>
                <label className="label1 mb-1" htmlFor={`relationshipNameInput`}>Month</label> <br />
                        <Input type="month" className="cardName filetype" onChange={(e) => { setInputMonth(e.target.value) }} id="file-upload-month" />
                </div>

        <div className="filter-item">
          <label>Entity</label>
          <Select
            options={entityOptions}
            value={selectedEntity ? { value: selectedEntity, label: selectedEntity } : null}
            onChange={handleEntityChange}
            isClearable
            placeholder="Select Entity"
          />
        </div>

        <div className="filter-item">
          <label>Division</label>
          <Select
            options={divisionOptions}
            value={selectedDivision ? { value: selectedDivision, label: selectedDivision } : null}
            onChange={handleDivisionChange}
            isClearable
            placeholder="Select Division"
          />
        </div>

        <div className="filter-item">
          <label>GL Code</label>
          <Select
            options={glCodeOptions}
            value={selectedGlCode ? { value: selectedGlCode, label: selectedGlCode } : null}
            onChange={handleGlCodeChange}
            isClearable
            placeholder="Select GL Code"
          />
        </div>

        <div className="filter-item">
          <label>Account Number</label>
          <Select
            options={acctNoOptions}
            value={selectedAcctNo ? { value: selectedAcctNo, label: selectedAcctNo } : null}
            onChange={handleAcctNoChange}
            isClearable
            placeholder="Select Account Number"
          />
        </div>

        <div className="filter-item">
          <label>GL Description</label>
          <Select
            options={glDescOptions}
            value={selectedGlDesc ? { value: selectedGlDesc, label: selectedGlDesc } : null}
            onChange={handleGlDescChange}
            isClearable
            placeholder="Select GL Description"
          />
        </div>
        <div  className="filter-item">
                <Button primary style={{ padding: '8px 12px', fontSize: '14px', backgroundColor: "#000055" }} onClick={handleSearchClick}>
                  Search
                </Button>
        </div>
    </div>
      </div>
<div style={{paddingTop: '70px'}}>
  {balanceData && (
    <div className="balance-info" style={{ padding: '20px', marginLeft: '250px',width:'50%',backgroundColor: '#f4f4f4', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)' }}>
      <h3 style={{ marginBottom: '20px', fontSize: '22px', fontWeight: 'bold' }}>Balance Details</h3>
      
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
        <div>
          <strong style={{ fontSize: '16px', color: '#333' }}>GL Code:</strong>
          <div style={{ fontSize: '16px', color: '#555' }}>{balanceData.gl_code}</div>
        </div>
        
        <div>
          <strong style={{ fontSize: '16px', color: '#333' }}>GL Description:</strong>
          <div style={{ fontSize: '16px', color: '#555' }}>{balanceData.gldesc}</div>
        </div>
        
        <div>
          <strong style={{ fontSize: '16px', color: '#333' }}>ERP Opening Balance:</strong>
          <div style={{ fontSize: '16px', color: '#555' }}>
            {balanceData.erp_opening_balance}
          </div>
        </div>
        
        <div>
          <strong style={{ fontSize: '16px', color: '#333' }}>Bank Opening Balance:</strong>
          <div style={{ fontSize: '16px', color: '#555' }}>
            {balanceData.bank_opening_balance}
          </div>
        </div>
        
        <div>
          <strong style={{ fontSize: '16px', color: '#333' }}>ERP Closing Balance:</strong>
          <div style={{ fontSize: '16px', color: '#555' }}>
            {balanceData.erp_closing_balance}
          </div>
        </div>
        
        <div>
          <strong style={{ fontSize: '16px', color: '#333' }}>Bank Closing Balance:</strong>
          <div style={{ fontSize: '16px', color: '#555' }}>
            {balanceData.bank_closing_balance}
          </div>
        </div>
      </div>
    </div>
  )}

</div>
<div style={{ paddingTop: '50px',width:'50%',marginLeft:'250px' }}>
  {balanceData && (
    <div className="filter-container" style={{ display: 'flex', gap: '15px', flexWrap: 'wrap' }}>
      {balanceData.close_status === 0 && (
<>
          <div className="filter-item" style={{ flex: '1 1 30%' }}>
            <Button 
              primary 
              style={{ padding: '8px 12px', fontSize: '14px', backgroundColor: "#000055" }} 
              onClick={monthendclosebalance }
            >
              Close
            </Button>
          </div>
          <div className="filter-item" style={{ flex: '1 1 30%' }}>
            <Button 
              primary 
              style={{ padding: '8px 12px', fontSize: '14px', backgroundColor: "#000055" }} 
              onClick={monthendfreezebalance}
            >
              Freeze
            </Button>
          </div>
</>
      )}
      
      {balanceData.close_status === 1 && (
        // Render no buttons when close_status is 1
        null
      )}
      
      {balanceData.close_status === 2 && (
<>
          <div className="filter-item" style={{ flex: '1 1 30%' }}>
            <Button 
              primary 
              style={{ padding: '8px 12px', fontSize: '14px', backgroundColor: "#000055" }} 
              onClick={monthendclosebalance}
            >
              Close
            </Button>
          </div>
          <div className="filter-item" style={{ flex: '1 1 30%' }}>
            <Button 
              primary 
              style={{ padding: '8px 12px', fontSize: '14px', backgroundColor: "#000055" }} 
              onClick={monthendunfreezebalance}
            >
              UnFreeze
            </Button>
          </div>
</>
      )}
    </div>
  )}
</div>
    </div>
  );
};

export default BalanceClosing;
